'use client'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useSession } from '@marketplace-web/shared/session-data'

type Props = {
  userId?: number
  business: boolean
  abTestName: string
  shouldExposeSelf?: boolean
}

const useSellerBadgeAbTest = ({ userId, business, abTestName, shouldExposeSelf = true }: Props) => {
  const isFastReplierBadgeEnabled = useFeatureSwitch('web_fast_replier_badge')
  const currentUser = useSession().user

  const isViewingSelf = currentUser?.id === userId
  const bothUsersNotBusiness = !!userId && !currentUser?.business && !business

  const shouldTrackAbTest =
    bothUsersNotBusiness && isFastReplierBadgeEnabled && (shouldExposeSelf || !isViewingSelf)
  const abTest = useAbTest(abTestName)
  useTrackAbTest(abTest, shouldTrackAbTest)
  useTrackAbTest(useAbTest(`${abTestName}_aa_test`), shouldTrackAbTest)

  return abTest
}

export default useSellerBadgeAbTest
